/*
 * Workaround for a Variantify regression (app extension release 2026-10-20,
 * "support-gardeners-cornerstone-pr193").
 *
 * Variantify gained a Dawn-specific grid detector, detectDawnMainCollectionGrid(),
 * which only accepts cards whose product handle is already present in
 * window.VariantifyProductsData. When Ajaxinate appends page N, those products
 * are not in the data yet - Variantify fetches them only AFTER it has seen the
 * new cards. The detector therefore reports zero cards, Variantify logs
 * "No product cards for PAGINATE - aborting", and every product loaded by
 * infinite scroll stays unsplit (no per-variant cards).
 *
 * The fix wraps window.MaincardDetect: when the main #product-grid comes back
 * empty while it still holds native (non-clone) Dawn cards, those cards are
 * reported, so Variantify proceeds to fetch page N and split it. Once the data
 * is merged, Variantify's own detection succeeds and the wrapper is a no-op.
 *
 * Normally this runs before variantify_split.js (both are deferred; this one is
 * earlier in the document) and the setter wraps Variantify's assignment; if
 * Variantify was first, the existing function is wrapped instead.
 * Remove it once Variantify ships a fix.
 */
(function () {
  if (window.__variantifyInfiniteScrollFix) return;
  window.__variantifyInfiniteScrollFix = true;

  const PRODUCT_HANDLE = /\/products\/([^/?#]+)/;

  function nativeCards(grid) {
    return [...grid.children]
      .filter(
        (card) =>
          card.matches('li:not([data-variantify="clone"]):not(.variantify-clone)') &&
          card.querySelector('.card-wrapper')
      )
      .map((wrapper) => {
        const link = wrapper.querySelector('a[href*="/products/"]');
        const match = link?.getAttribute('href')?.match(PRODUCT_HANDLE);
        return match ? { wrapper, handle: decodeURIComponent(match[1]) } : null;
      })
      .filter(Boolean);
  }

  function withPaginatedCards(detect) {
    return function () {
      const result = detect.apply(this, arguments);
      const first = Array.isArray(result) ? result[0] : result;
      const grid = document.getElementById('product-grid');
      if (!first || !grid || first.gridElement !== grid || first.productCards?.length) return result;

      const productCards = nativeCards(grid);
      if (!productCards.length) return result;

      first.productCards = productCards;
      first.handles = [...new Set(productCards.map((card) => card.handle))];
      return result;
    };
  }

  const existing = window.MaincardDetect;
  let wrapped;
  Object.defineProperty(window, 'MaincardDetect', {
    configurable: true,
    get() {
      return wrapped;
    },
    set(detect) {
      wrapped = typeof detect === 'function' ? withPaginatedCards(detect) : detect;
    },
  });
  if (existing) window.MaincardDetect = existing;
})();
